import React, { useRef } from 'react';
import classNames from 'classnames';
import renderIcon from '../../utils/renderIcon';

const ns = `radio`;

const Radio = ({
	id,
	name,
	checked,
	label,
	disabled,
	onChange = () => {},
	...props
}) => {
	const checkboxRef = useRef();

	const handleChange = e => {
		onChange(e);
	};

	const rootClassnames = classNames({
		[`${ ns }`]: true,
		[`${ ns }--checked`]: checked,
		[`${ ns }--disabled`]: disabled,
	});

	return (
		<label htmlFor={id} className={rootClassnames}>
			<span aria-hidden>
				{renderIcon('radio')}
			</span>
			<input
				{...props}
				id={id}
				name={name}
				ref={checkboxRef}
				type={`radio`}
				checked={checked}
				onChange={handleChange}
				disabled={disabled}
			/>
			{/* <RenderStaticHTML
				html={label}
				as={`span`}
			/> */}
			<span>{label}</span>
		</label>
	);
};

export default Radio;
